import { render } from "./ReviewList.vue?vue&type=template&id=a986073e&scoped=true&ts=true"
import script from "./ReviewList.vue?vue&type=script&lang=ts"
export * from "./ReviewList.vue?vue&type=script&lang=ts"

import "./ReviewList.vue?vue&type=style&index=0&id=a986073e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a986073e"]])

export default __exports__